// extracted by mini-css-extract-plugin
export default {"container":"MainSection_container__Kaffa","imageGroup":"MainSection_imageGroup__0t0p3","h2":"MainSection_h2__dWNJy","whiteBlocksAnchor":"MainSection_whiteBlocksAnchor__IRkAg"};